import styled, { css } from 'styled-components';
import { FunctionColor } from '@lux/tokens';
import {
    Screen,
    screenBiggerThan,
    screenSmallerThan,
} from '@client/styles/styled-components/breakpoints';

export const Wrapper = styled.a<{
    $x: number;
    $y: number;
    $w: number;
    $h: number;
    minHeight: number;
}>`
    ${({ $h, $w, $y, $x, minHeight }) => css`
        height: 100%;
        position: relative;
        width: 100%;
        visibility: visible;
        background-size: 100%;
        background-repeat: no-repeat;
        transition: all 0.33s ease-in-out;
        min-height: ${minHeight};
        ${screenBiggerThan(Screen.mobile)} {
            grid-column: ${$x + 1} / span ${$w};
            grid-row: ${$y + 1} / span ${$h};
        }
        &:hover,
        &:focus-within {
            .overlay {
                visibility: visible;
                opacity: 1;
            }
            .delivery-label {
                visibility: hidden;
                opacity: 0;
            }
        }
    `}
`;

export const EarlyAccessWrapper = styled.div`
    position: absolute;
    top: 0;
`;

export const ImageWrapper = styled.div<{ withoutLogo: boolean }>`
    position: relative;
    ${({ withoutLogo }) =>
        withoutLogo &&
        css`
            &::before {
                content: ' ';
                background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.03) 31.74%,
                    rgba(0, 0, 0, 0.3) 90%
                );
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
            }
        `}
`;

export const CampaignImage = styled.img`
    width: 100%;
    object-fit: cover;
`;

export const InnerWrapper = styled.div<{ isHideCgExperiment: boolean }>`
    height: ${props => (props.isHideCgExperiment ? '65px' : '75px')};
    ${screenSmallerThan(Screen.smallTablet)} {
        height: 90px;
    }
`;

export const Title = styled.div`
    position: absolute;
    width: 100%;
    text-align: center;
    color: ${FunctionColor.function0};
    font-weight: 700;
    z-index: 2;
    font-size: 18px;
    padding: 20px 8px 0;
    bottom: 60px;
`;
